<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 overflow-auto">
              <b-card>
                <b-table
                  :stacked="$mobile == 1"
                  responsive="sm"
                  :items="data"
                  :fields="userfields"
                >
                  <template #cell(activities)="data">
                    <button
                      v-b-modal="'modal-center-' + data.item.id"
                      class="btn btn-primary"
                    >
                      عرض الأنشطة
                    </button>
                  </template>
                  <template #cell(pivot.edu_program_id)="data">
                  <h4>
                    <b-badge variant="primary">
                      {{ data.item.pivot.edu_program_id }}
                    </b-badge>
                  </h4>
                  </template>
                  <!-- <template #cell(activities)="data">
                    {{data}}
                    <b-modal
                      :id="'modal-center-' + data.item.id"
                      title="الأنشطة"
                      size="lg"
                    >
                      <b-row>
                        <b-col lg="12">
                          <b-table
                            :stacked="$mobile == 1"
                            responsive="sm"
                            :items="
                              activities.filter(
                                (a) => a.edu_course_id == data.item.id
                              )
                            "
                            :fields="['الأسم', 'الدرجة']"
                          >
                            <template #cell(الأسم)="data">
                              {{ data.item.name }}
                            </template>
                            <template #cell(الدرجة)="data">
                              {{ data.item.grade }} / {{ data.item.bestGrade }}
                            </template>
                          </b-table>
                        </b-col>
                      </b-row>
                    </b-modal>
                    <button
                      v-b-modal="'modal-center-' + data.item.id"
                      class="btn btn-primary"
                    >
                      عرض الأنشطة
                    </button>
                  </template> -->
                </b-table>
                <b-spinner
                  v-if="load"
                  type="grow"
                  label="Loading..."
                  class="loading"
                />
              </b-card>
            </div>
            <!-- end of col -->
          </div>

          <hr />

          <!-- end of row -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Auth from "@/Apis/Auth";
import controller from "@/Controllers/EduProgramsController";

import flatPickr from "vue-flatpickr-component";

export default {
  name: "QuranProgramsDataTable",
  components: {
    flatPickr,
  },

  data() {
    return {
      dateNtim: null,
      itemView: "DataTable",
      controller: new controller(),
      title: "",
      newDate: {},
      draft: 1,

      data: [],

      search: "",
      from: 0,
      total: 0,
      totalRows: 0,
      to: 0,
      lastPage: 0,
      load: false,
      userfields: [
        {
          key: "code",
          label: this.$i18n.t("edu_courses.code"),
          sortable: true,
        },
        {
          key: "name",
          label: this.$i18n.t("edu_courses.name"),
          sortable: true,
        },

        {
          key: "activities",
          label: "الأنشطة",
          sortable: false,
        },
        {
          key: "pivot.edu_program_id",
          label: "البرنامج",
          sortable: false,
        },
        // {
        //   key: "ch",
        //   label: "CH",
        //   sortable: true,
        // },
      ],
    };
  },
  async created() {
    // this.itemView = "grid-view";
    const itemViewOptions = [
      { icon: "GridIcon", value: "grid-view" },
      { icon: "ListIcon", value: "list-view" },
    ];
    this.data = await this.controller.GetAllCourses();
  },

  methods: {
    refresh() {
      this.$refs.table.refresh();
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      //keep the params

      this.$refs.vuetable.changePage(page);
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/base/pages/app-ecommerce.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style lang="scss" scoped>
.item-view-radio-group ::v-deep {
  .btn {
    display: flex;
    align-items: center;
  }
}
</style>
